module.exports = __webpack_public_path__ + "static/img/CO@2x.6b201fc7.jpg";